import { normalize } from 'normalizr'
import { Schemas } from '../../../shared/redux/schema'
import { updateEntities, deleteEntity } from '../../../shared/redux/entity'
import { encodeParams } from '../../../shared/functions/utilities'

const FETCH_REQUEST = 'realhub/artworkPageItem/FETCH_REQUEST'
const FETCH_SUCCESS = 'realhub/artworkPageItem/FETCH_SUCCESS'
const FETCH_FAILURE = 'realhub/artworkPageItem/FETCH_FAILURE'
const INITIAL_RENDER = 'realhub/artworkPageItem/INITIAL_RENDER'
const REBUILD_RENDERS = 'realhub/artworkPageItem/REBUILD_RENDERS'
const UPDATE_QUEUE = 'realhub/artworkPageItem/UPDATE_QUEUE'

// Initial State
const initialState = {
  result: [],
  loaded: false,
  loading: false,
  loadedItemsForArtworkPageIds: [],
  queuedItems: [],
  creating: false,
  rendering: false,
  initialRender: true,
  errors: [],
}

// Actions
export function fetchRequest(payload = {}){
  return {
    type: FETCH_REQUEST,
    loading: true,
    loadedItemsForArtworkPageIds: payload.loadedItemsForArtworkPageIds,
  }
}

export function fetchSuccess(payload = {}){
  return {
    type: FETCH_SUCCESS,
    loading: false,
    loaded: true,
    loadedItemsForArtworkPageIds: payload.loadedItemsForArtworkPageIds,
    errors: [],
    result: payload.result,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    loaded: false,
    loading: false,
    errors,
  }
}

export function initialRender(){
  return {
    type: INITIAL_RENDER,
    initialRender: false,
  }
}

export function rebuildRenders(payload = {}){
  return {
    type: REBUILD_RENDERS,
    rendering: true,
    initialRender: true,
    result: payload.result,
  }
}

export function updateQueue(payload = {}){
  return {
    type: UPDATE_QUEUE,
    queuedItems: payload.queuedItems,
  }
}

// Action Creators
export function loadItemsForArtworkPage(artworkPageId){
  return (dispatch, getState) => {
    const loadedItemsForArtworkPageIds = getState().artworkPageItems.loadedItemsForArtworkPageIds ? getState().artworkPageItems.loadedItemsForArtworkPageIds.slice() : []
    if (artworkPageId && loadedItemsForArtworkPageIds.indexOf(artworkPageId) == -1){
      loadedItemsForArtworkPageIds.push(artworkPageId)
    }
    dispatch(fetchRequest({ loadedItemsForArtworkPageIds }))
  }
}

export function loadArtworkPageItems(options){
  const config = {
    method: 'GET',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
  }

  return (dispatch, getState) => {
    // Set Loading
    const loadedItemsForArtworkPageIds = getState().artworkPageItems.loadedItemsForArtworkPageIds ? getState().artworkPageItems.loadedItemsForArtworkPageIds.slice() : []
    if (options.artwork_page_id && loadedItemsForArtworkPageIds.indexOf(options.artwork_page_id) == -1){
      loadedItemsForArtworkPageIds.push(options.artwork_page_id)
    }
    dispatch(fetchRequest({ loadedItemsForArtworkPageIds }))

    // Encode Params
    const params = options ? `?${encodeParams(options)}` : ''
    const promise = fetch(`/agency/artworks/${options.artwork_id}/pages/${options.artwork_page_id}/items.json${params}`, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.ARTWORK_PAGE_ITEM_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess({ result: normalizedJson.result }))
      })
      .catch((json) => {
        const errors = json.errors ? json.errors : ['Something went wrong...']
        dispatch(fetchFailure(errors))
      })

    return promise
  }
}

export function deleteArtworkPageItemRenders(artworkPage){
  return (dispatch, getState) => {
    const resultArray = getState().artworkPageItems.result ? getState().artworkPageItems.result.slice() : []

    const artworkPageItems = getState().entities.artworkPageItems
    const keys = Object.keys(artworkPageItems)

    for (let i = 0; i < keys.length; i++){
      const artworkPageItem = artworkPageItems[keys[i]]
      if (artworkPageItem.artwork_page_id == artworkPage.id){
        const deletedItem = Object.assign({}, artworkPageItem)

        const index = resultArray.indexOf(deletedItem.id)
        if (index !== -1){
          resultArray.splice(index, 1)
        }

        // Update
        const normalizedJson = normalize(deletedItem, Schemas.ARTWORK_PAGE_ITEM)
        dispatch(deleteEntity(normalizedJson))
      }
    }

    dispatch(rebuildRenders({ result: resultArray }))
  }
}

export function deleteRendersForArtworkDataKeys(artworkPage, artworkDataKeys = []){
  return (dispatch, getState) => {
    const artworkPageItems = getState().entities.artworkPageItems
    const keys = Object.keys(artworkPageItems)

    keys.forEach((key) => {
      const artworkPageItem = artworkPageItems[key]
      if (artworkPageItem.artwork_page_id === artworkPage.id &&
        artworkDataKeys.includes(artworkPageItem.artwork_data_key)
      ){
        const updatedArtworkPageItem = Object.assign({}, artworkPageItem)
        updatedArtworkPageItem.render_url = null

        const normalizedJson = normalize(updatedArtworkPageItem, Schemas.ARTWORK_PAGE_ITEM)
        dispatch(updateEntities(normalizedJson))
      }
    })
  }
}

export function clearArtworkPageItemRender(artworkPage, templatePageItem){
  return (dispatch, getState) => {
    const artworkPageItems = getState().entities.artworkPageItems
    const keys = Object.keys(artworkPageItems)

    let updatedArtworkPageItem
    for (let i = 0; i < keys.length; i++){
      const artworkPageItem = artworkPageItems[keys[i]]
      if (artworkPageItem.artwork_page_id == artworkPage.id && artworkPageItem.artwork_data_key == templatePageItem.artwork_data_key){
        updatedArtworkPageItem = Object.assign({}, artworkPageItem)
        updatedArtworkPageItem.render_url = null
      }
    }

    const json = updatedArtworkPageItem || Object.assign({}, templatePageItem)
    const normalizedJson = normalize(json, Schemas.ARTWORK_PAGE_ITEM)
    dispatch(updateEntities(normalizedJson))
  }
}

export function renderArtworkPageItems(artworkPage, templatePageItems){
  return (dispatch, getState) => {
    templatePageItems.forEach((templatePageItem) => {
      dispatch(renderArtworkPageItem(artworkPage, templatePageItem))
    })

    dispatch(initialRender())
  }
}

export function renderArtworkPageItem(artworkPage, templatePageItem){
  const config = {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      v2: true,
      template_page_item_id: templatePageItem.id,
      artwork_data_key: templatePageItem.artwork_data_key,
      parent_type: templatePageItem.parent ? templatePageItem.parent.item_type : null,
      parent_id: templatePageItem.parent ? templatePageItem.parent.id : null,
      parent_scale: templatePageItem.scale ? templatePageItem.scale : null,
      position: {
        x: templatePageItem.x,
        y: templatePageItem.y,
      },
    }),
  }

  return (dispatch, getState) => {
    // Add to Queue
    const queuedItems = modifyItemQueue(getState(), templatePageItem, 'add')
    dispatch(updateQueue({ queuedItems }))

    // Set Loading
    const loadedItemsForArtworkPageIds = getState().artworkPageItems.loadedItemsForArtworkPageIds ? getState().artworkPageItems.loadedItemsForArtworkPageIds.slice() : []
    const index = loadedItemsForArtworkPageIds.indexOf(artworkPage.id)
    if (index == -1){
      loadedItemsForArtworkPageIds.push(artworkPage.id)
    }

    dispatch(fetchRequest({ loadedItemsForArtworkPageIds }))

    // Encode Params
    const promise = fetch(`/agency/artworks/${artworkPage.artwork_id}/pages/${artworkPage.id}/items/render_item.json`, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        // Add to Result Array
        const resultArray = getState().artworkPageItems.result ? getState().artworkPageItems.result.slice() : []
        const index = resultArray.indexOf(json.id)
        if (index == -1){
          resultArray.push(json.id)
        }

        // Update Entity
        const normalizedJson = normalize(json, Schemas.ARTWORK_PAGE_ITEM)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess({ result: resultArray }))

        // Remove from Queue
        const queuedItems = modifyItemQueue(getState(), templatePageItem, 'remove')
        dispatch(updateQueue({ queuedItems }))
      })
      .catch((json) => {
        // Return Error
        const errors = json.errors ? json.errors : ['Something went wrong...']
        dispatch(fetchFailure(errors))
      })

    return promise
  }
}

function modifyItemQueue(state, templatePageItem, action = 'add'){
  const itemKey = templatePageItem.artwork_data_key

  const queuedItems = state.artworkPageItems.queuedItems ? state.artworkPageItems.queuedItems.slice() : []
  const queueIndex = queuedItems.indexOf(itemKey)

  // Add to Queue
  if (action == 'add' && queueIndex == -1){
    queuedItems.push(itemKey)
  }

  // Remove from Queue
  if (action == 'remove' && queueIndex !== -1){
    queuedItems.splice(queueIndex, 1)
  }

  return queuedItems
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        loadedItemsForArtworkPageIds: action.loadedItemsForArtworkPageIds,
      })
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        result: action.result,
        errors: [],
      })
    case FETCH_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        loaded: false,
        errors: action.errors,
      })
    case INITIAL_RENDER:
      return Object.assign({}, state, {
        initialRender: false,
      })
    case REBUILD_RENDERS:
      return Object.assign({}, state, {
        initialRender: true,
        result: action.result,
      })
    case UPDATE_QUEUE:
      return Object.assign({}, state, {
        queuedItems: action.queuedItems,
      })
    default:
      return state
  }
}
